export enum SoftSkillEnum {
  Communiquant = 'COMMUNIQUANT',
  Autonome = 'AUTONOME',
  Flexible = 'FLEXIBLE',
  Perseverant = 'PERSEVERANT',
  Positif = 'POSITIF',
  Creatif = 'CREATIF',
  Convaincant = 'CONVAINCANT',
  Innovant = 'INNOVANT',
  EspritEquipe = 'ESPRIT_EQUIPE',
  Curieux = 'CURIEUX',
  Reactif = 'REACTIF',
  Rigoureux = 'RIGOUREUX',
  EspritAnalyse = 'ESPRIT_ANALYSE',
  Entreprenant = 'ENTREPRENANT',
}
